import _ from 'underscore'
import {watch,saveIdObject,deleteIdObject,getRef} from './common'

export function loadRoutes() {
  return watch('routes')
}

export function deleteRoute({id}) {
  deleteIdObject('routes',id)
}

function purify(route){
  if(route.bolts) {
    route.bolts = _.pick(route.bolts,
      'A01',
      'A02',
      'B01',
      'B02',
      'B03',
      'B04',
      'B05',
      'B06',
      'B07',
      'B08',
      'B09',
      'B10',
      'B11',
      'B12',
      'B13',
      'B14',
      'B15',
      'B16')
  }

  return _.pick(route,
    'id',
    'name',
    'nameEN',
    'grade',
    'length',
    'style',
    'description',
    'descriptionEN',

    'area',
    'region',

    'FAName',
    'FADate',

    //Bolt
    'safety',
    'shareAnchor',
    'changeAnchor',
    'bolts',
    'notes',

    'ticks',
    )
}

export function saveRoute(route) {
  return saveIdObject('routes',purify(route))
}

export function updateRouteBolts(route) {
  getRef('routes').child(route.id).child('bolts').set(route.bolts)
}




/** WEBPACK FOOTER **
 ** ./src/app/actions/routes.js
 **/